module.exports = __webpack_public_path__ + "img/language-solid updated.80c0a07c.svg";